module.exports = __webpack_public_path__ + "img/thumbnail_AmurLeopard_j_melanistic.ffec2ea4.png";